









































import { Vue, Component, Prop } from "vue-property-decorator";
import AnxTitle from "../AnxTitle/AnxTitle.vue";

/**
 * The *anx-paragraph* is a computed version of the default HTML \<p\> tag that matches our styleguideline.
 */
@Component({
  components: {
    AnxTitle
  }
})
export default class AnxParagraph extends Vue {
  /** The title of the paragrapg */
  @Prop({ default: null }) title!: string | null;

  /** The size of the paragraph (h1, h2 or h3) */
  @Prop({ default: "h1" }) size!: string;

  /** The paragraph can also be displayed as hint */
  @Prop({ default: null }) hint!: boolean | null;

  /** The paragraph title has a line or not */
  @Prop({ default: null }) noline!: boolean | null;

  /** Inverse the colors of the paragraph */
  @Prop({ default: null }) inverse!: boolean | null;

  /** No margin after the title */
  @Prop({ default: null }) noMarginTitle!: boolean | null;

  /** This is the element that will be inserted for anx-paragraph */
  @Prop({ default: "p" }) element!: string;

  /** Margin bottom for the paragraph */
  @Prop({ default: null }) marginBottom!: string | null;
}
